import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { resolveApiBase } from './app/core/api-base';

function bootstrap(): void {
  bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
}

// When serve-pages falls back (302 → /?...), the SPA lands at '/' with the
// original OAuth query string intact. If a custom sign-in page is published,
// redirect to /login before Angular starts so the default login UI never
// flickers into view. On any error (network, non-OK status) bootstrap normally.
const clientId = new URLSearchParams(window.location.search).get('client_id');
if (clientId && window.location.pathname === '/') {
  fetch(`${resolveApiBase()}/pages/sign-in?client_id=${encodeURIComponent(clientId)}`)
    .then(r => r.ok ? r.json() as Promise<{ published?: boolean }> : Promise.reject())
    .then(data => {
      if (data.published) {
        window.location.replace('/login' + window.location.search);
      } else {
        bootstrap();
      }
    })
    .catch(() => bootstrap());
} else {
  bootstrap();
}
